import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import { forgotpasswordCognitoUser } from '@utils/authenticateService'
import { IForgotPasswordPayload } from '@app-store/slices/auth/forgotPassword.slice'
import { notification } from 'antd'

interface TaskAction extends Action, ITask {}
interface ITask {
    payload: IForgotPasswordPayload
}

const { onFailure, onSuccess, onRequest } = rootActions.auth.forgotPassword

function* forgotPasswordSagaTask({ payload }: TaskAction) {
    try {
        const response = yield forgotpasswordCognitoUser(payload.data)
        yield payload.sagaCB?.onSuccess()
        notification.success({
            message: 'Confirmation code has been sent to your email.'
        })
        yield put(onSuccess(response))
    } catch (e) {
        yield put(onFailure(['Email is incorrect.']))
    }
}

function* forgotPasswordSaga(): any {
    yield takeLatest<TaskAction>(onRequest, forgotPasswordSagaTask)
}

export default forgotPasswordSaga
